angular.module('lf.common')

.directive('validCardholderName', function (validationService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, el, attrs, model) {
      var validator = function (val) {
        var valid = model.$isEmpty(val) || validationService.creditCard.validateCardholderName(val);
        model.$setValidity('cardholderName', valid);
        return val;
      }
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
